









import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { LMap, LTileLayer, LMarker, LIcon, LPopup, LPolyline } from 'vue2-leaflet';
import L, { MapOptions, latLng, LatLng, Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { ContextsState, SettingsState } from '@/store';
// fix for default icon
type D = Icon.Default & {
    _getIconUrl: string;
};
delete (Icon.Default.prototype as D)._getIconUrl;

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPopup,
        LPolyline
    },
})

export default class MapTemplate extends Vue {
    // Chart data
    @Prop({ default: () => ([]) }) public channels!: any[];
    @Prop({ default: () => ([]) }) public vehicleMarkers!: any[];
    @Prop({ default: () => ([]) }) public siteMarkers!: any[];
    @Prop({ default: latLng(0, 0) }) public center!: LatLng;
    @Prop({ default: 5 }) public _zoom!: number;
    @Prop({ default: 1 }) public _zoomSnap!: number;

    public url: string = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    public channelColor = '#5D90FC';
    public mapOptions: MapOptions = {
        zoomControl: false,
        zoom: this._zoom,
        zoomDelta: 0.2,
        zoomSnap: 0.2,
        dragging: false,
        touchZoom: false,
        scrollWheelZoom: false,
        doubleClickZoom: false,
        boxZoom: false,
        tap: false,
        keyboard: false,
        inertia: false,
        attributionControl: false,
        fadeAnimation: false,
        zoomAnimation: false,
    };

    public map: LMap | null = null;

    public mounted() {
        const mapDivName = 'logisticMapElement';
        this.map = this.$refs[mapDivName] as LMap;
    }

    public setZoom(zoom: number) {
        this.map?.mapObject.setZoom(zoom);
    }

    public panTo(center: any, settings: any) {
        this.map?.mapObject.panTo(center, settings);
    }

    public getPopup(info: any[]) {
        let html: string = '';
        info.map((v) => {
            html += `${v}</br>`;
            return html;
        });
        return html;
    }

    private get urlMap() {
        const url =
            SettingsState.contextSettings.global.urlMap ?? 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        return url;
    }

    private data() {
        return {
            zoom: this._zoom,
            zoomDelta: this._zoomSnap,
            zoomSnap: this._zoomSnap,
        };
    }
}
